/* eslint-disable react/prop-types */
import React, { Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import { SuspenseLoader } from '~/common/components/SuspenseLoader';
import decodeToken from '~/common/utils/decodeJwtToken';
import ConfirmTransfer from './RemoveCar/ConfirmTransfer';

const RegistrationInfo = React.lazy(() =>
  import(/* webpackChunkName: "AddCar" */ './AddCar/RegistrationInfo')
);
const UploadDocuments = React.lazy(() =>
  import(/* webpackChunkName: "UploadDocuments" */ './AddCar/UploadDocuments')
);
const RenameCar = React.lazy(() =>
  import(/* webpackChunkName: "RenameCar" */ './AddCar/RenameCar')
);
const SetUpCharging = React.lazy(() =>
  import(/* webpackChunkName: "SetUpCharging" */ './AddCar/SetUpCharging')
);
const AddCarSuccess = React.lazy(() =>
  import(/* webpackChunkName: "AddCarSuccess" */ './AddCar/AddCarSuccess')
);

const NewOwnerInformation = React.lazy(() =>
  import(/* webpackChunkName: "NewOwnerInformation" */ './RemoveCar/NewOwnerInformation')
);
const FactoryReset = React.lazy(() =>
  import(/* webpackChunkName: "FactoryReset" */ './RemoveCar/FactoryReset')
);
const SubmitTransfer = React.lazy(() =>
  import(/* webpackChunkName: "SubmitTransfer" */ './RemoveCar/SubmitTransfer')
);
const ConfirmationEmail = React.lazy(() =>
  import(/* webpackChunkName: "ConfirmationEmail" */ './RemoveCar/ConfirmationEmail')
);
const RemoveCarSuccess = React.lazy(() =>
  import(/* webpackChunkName: "RemoveCarSuccess" */ './RemoveCar/RemoveCarSuccess')
);
const RemoveCarError = React.lazy(() =>
  import(/* webpackChunkName: "RemoveCarError" */ './RemoveCar/RemoveCarError')
);

export default () => {
  return (
    <Suspense fallback={<SuspenseLoader />}>
      <Switch>
        <Route path="/add-car" exact component={RegistrationInfo} />
        <Route path="/add-car/upload-documents" exact component={UploadDocuments} />
        <Route path="/add-car/rename-car" component={RenameCar} />
        <Route path="/add-car/setup-charging" component={SetUpCharging} />
        <Route path="/add-car/success" component={AddCarSuccess} />
        <Route path="/remove-car/new-owner-information" component={NewOwnerInformation} />
        <Route path="/remove-car/factory-reset" component={FactoryReset} />
        <Route path="/remove-car/submit-transfer" component={SubmitTransfer} />
        <Route path="/remove-car/confirmation-email" component={ConfirmationEmail} />
        <Route
          path="/remove-car/confirm-transfer"
          component={props => {
            const params = new URLSearchParams(props.location.search);
            const { FullName: fullName, Email: email } = decodeToken(params);
            return fullName && email && <ConfirmTransfer fullName={fullName} email={email} />;
          }}
        />
        <Route path="/remove-car/success" component={RemoveCarSuccess} />
        <Route
          path="/remove-car/error"
          component={props => {
            const params = new URLSearchParams(props.location.search);
            const isTokenExpired = params.get('error-status') === 'token-expired';
            return <RemoveCarError isTokenExpired={isTokenExpired} />;
          }}
        />
      </Switch>
    </Suspense>
  );
};
